import { render, staticRenderFns } from "./Initiatives.vue?vue&type=template&id=185c3086&"
import script from "./Initiatives.vue?vue&type=script&lang=js&"
export * from "./Initiatives.vue?vue&type=script&lang=js&"
import style0 from "./Initiatives.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports